import ThemeProvider from '@/themes'
import UnhandledError from '@/views/error-pages/UnhandledError'
import router from '@/views/Router/Router'
import { IPublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LicenseInfo } from '@mui/x-license'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import { ErrorBoundary } from 'react-error-boundary'
import { RouterProvider } from 'react-router-dom'

import './App.css'
import { QueryClientProvider } from './providers'

dayjs.extend(quarterOfYear)
// Registered explicitly for the 'll' style formats. AdapterDayjs also extends it, but only as a
// side effect of being imported, which leaves those formats printing literally wherever it isn't.
dayjs.extend(localizedFormat)

// Set the MUI license key
LicenseInfo.setLicenseKey(
	'f2040b6f71d422dd6a1f0eb17f2d06daTz0xMzExMDUsRT0xODE1NjA5NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI='
)

type Props = {
	pca: IPublicClientApplication
}

export default function App({ pca }: Props) {
	return (
		<MsalProvider instance={pca}>
			<ThemeProvider>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<ErrorBoundary FallbackComponent={UnhandledError}>
						<QueryClientProvider>
							<RouterProvider router={router} />
						</QueryClientProvider>
					</ErrorBoundary>
				</LocalizationProvider>
			</ThemeProvider>
		</MsalProvider>
	)
}
